import React from 'react';
import ReactDatePicker from 'react-datepicker';
import styled from 'styled-components';
import { colors } from 'styleguide';

import ValueBox from 'craft/containers/Toolbox/components/ValueBox';
import { useMultiNodes } from 'craft/hooks';
import { PropToEdit } from 'craft/types';

const StyledValueBox = styled(ValueBox)`
  .react-datepicker-wrapper {
    flex: 3;
  }
`;

const StyledDatePicker = styled(ReactDatePicker)`
  outline: none;
  padding: 0.5em;
  border: 1px solid ${colors('neutral', 3)};
  border-width: 0px 0px 0px 1px;
`;

interface Props {
  nodeIds: string[];
  propToEdit: PropToEdit;
}

const DateField = ({ nodeIds, propToEdit }: Props) => {
  const {
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const { schema, value: currentValue } = propToEdit;
  const value = currentValue || schema.fieldType.defaultValue || '';

  const onChange = (date: Date) => {
    setProps({ [schema.id]: date ? date.toISOString() : null });
  };

  return (
    <StyledValueBox label={schema.name}>
      <StyledDatePicker
        selected={value ? new Date(value) : undefined}
        onChange={onChange}
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false,
            boundariesElement: 'viewport',
          },
        }}
      />
    </StyledValueBox>
  );
};

export default DateField;
